import { FederatedRegistry } from 'flop-module-federation/FederatedRegistry';
import React, { PropsWithChildren } from 'react';

// to be able to test different scopes from QA
const flopModuleFederationScopeOverride =
    (import.meta.env.VITE_FLOP_MODULE_FEDERATION_ORCHESTRATOR_ALLOW_SCOPE_OVERRIDE === "true")
        ? new URLSearchParams(window.location.search).get("flopModuleFederationScopeOverride")
        : undefined;

const FlopModuleFederatedRegistryRoot: React.FC<PropsWithChildren<unknown>> = (props) => {
    return (
        <FederatedRegistry
            scope={flopModuleFederationScopeOverride ?? (import.meta.env.VITE_FLOP_MODULE_FEDERATION_ORCHESTRATOR_SCOPE as string)}
            orchestratorUrl={(import.meta.env.VITE_FLOP_MODULE_FEDERATION_ORCHESTRATOR_URL as string)}
        >
            {props.children}
        </FederatedRegistry>
    );
}

export default FlopModuleFederatedRegistryRoot;